export default __webpack_public_path__ + "static/media/portfolio-laptop-main.15bed59e.webp";